import { useParams } from 'react-router-dom'
import useGetLoans from '../../hooks/useGetLoans'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import useDeleteLoan from '../../hooks/useDeleteLoan'
import { useCallback } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

export default function Requested() {
    const { id } = useParams()
    const { demandLoans, isLoadingDemandLoans, refetch, fetchNextPage } =
        useGetLoans(id)
    const { isLoading, mutate } = useDeleteLoan(refetch)
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <div className=" pb-16">
            {!isLoadingDemandLoans && demandLoans ? (
                <>
                    <InfiniteScroll
                        next={onWatchEnd}
                        hasMore={
                            demandLoans
                                ? demandLoans?.pages[
                                      demandLoans.pages.length - 1
                                  ].next
                                    ? true
                                    : false
                                : false
                        }
                        dataLength={
                            demandLoans
                                ? demandLoans.pages.flatMap((x) => x.results)
                                      .length
                                : 0
                        }
                        loader={<DotsLoading />}
                    >
                        <>
                            {demandLoans.pages
                                .flatMap((x) => x.results)
                                .map((item) => (
                                    <Item
                                        item={item}
                                        key={item.id}
                                        isLoading={isLoading}
                                        mutate={mutate}
                                    />
                                ))}
                        </>
                    </InfiniteScroll>
                </>
            ) : (
                <DotsLoading />
            )}
        </div>
    )
}
